import React, {useState} from 'react';
import './Header.css'
import Hamburger from 'hamburger-react'
import { NavLink, Link } from 'react-router-dom';
const Header = () => {
    const [isOpen, setOpen] = useState(false)
    return (
        <div>
            <nav className="navbar navbar-expand-lg ">
                <div className="container">
                    <Link className="navbar-brand navbarName" to="/home">  Shishir Saha </Link>
                    <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
                    <span> <Hamburger toggled={isOpen} toggle={setOpen} direction="right" color="#4FD1C5" easing="ease-in" /> </span>
                    </button>
                    <div className="collapse navbar-collapse" id="navbarNav">
                    <ul className="navbar-nav ms-auto">
                        <li className="nav-item">
                        <NavLink activeClassName="menu_Item" className="nav-link"
                       to="/skill">Skill</NavLink>
                        </li>
                        <li className="nav-item">
                        <NavLink activeClassName="menu_Item" className="nav-link"
                       to="/about">About Me</NavLink>
                        </li>
                        <li className="nav-item">
                        <NavLink activeClassName="menu_Item" className="nav-link"
                       to="/experience">Experiences</NavLink>
                        </li>
                        <li className="nav-item">
                        <NavLink activeClassName="menu_Item" className="nav-link"
                       to="/projects">Projects</NavLink>
                        </li>
                        <li className="nav-item">
                        <NavLink activeClassName="menu_Item" className="nav-link"
                       to="/blogs">Blogs</NavLink>
                        </li>
                        <li className="nav-item">
                        <Link className="nav-link contactMeBtn" to="/contact">Contact Me</Link>
                        </li>
                    </ul>
                    </div>
                </div>
            </nav>

        </div>
    
    );
};

export default Header;